import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Control, Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import { DateView } from '@mui/x-date-pickers';
export const FormDatePicker = ({
	name,
	control,
	label,
	rules,
	views = ['year', 'month', 'day'],
	format = 'YYYY-MM-DD',
	disablePast = false,
	helperText
}: {
	name: string;
	control: Control<any, any>;
	label: string;
	rules?: Record<string, unknown>;
	views?: DateView[];
	format?: string;
	disablePast?: boolean;
	helperText?: string;
}) => {
	return (
		<Controller
			name={name}
			control={control}
			rules={rules}
			render={({ field: { onChange, value }, fieldState: { error } }) => {
				return (
					<DatePicker
						slotProps={{
							textField: {
								helperText: error ? error.message : helperText || null,
								size: 'small',
								error: !!error,
								fullWidth: true,
								variant: 'outlined'
							},
							field: { clearable: true }
						}}
						onChange={(date) => onChange(date ? date.format(format) : '')}
						value={value ? dayjs(value) : null}
						format={format}
						views={views}
						label={label}
						disablePast={disablePast}
					/>
				);
			}}
		/>
	);
};
//field: { clearable: true, onClear: () => setCleared(true) },
